<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">

                    <b-col cols="3" class="text-left">
                        <lg-form-input v-model="form.descricao" label="Descrição:" />
                    </b-col>

                    <b-col cols="4">

                        <lg-form-input-number description=" " v-model.number="form.localArmazenamentoPai"
                            label="Localização Física Pai:" :precision="{ min: 0, max: 0 }" />

                    </b-col>



                    <b-col cols="3" class="text-left">
                        <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativaLocal"
                            :podeMudarDepartamento="departamento == null" :podeApagarDepartamento="departamento == null"
                            v-model="form.unidadeAdministrativa" @onselect="handleSelectUnidadeAdministrativa"
                            invalidFeedback="">
                        </lg-finder-page-unidade-administrativa>
                    </b-col>
                    <b-col cols="2" class="text-right mt-2">

                        <b-button v-if="temPrivilegioInclusao()" id="plus" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="mostrarModal">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" /> &nbsp;
                            </div>
                            <b-tooltip target="plus" title="Adicionar novo..."></b-tooltip>
                        </b-button>


                    </b-col>


                    <b-col lg="5" sm="12" class="text-left">
                        <lg-finder-page-tipo-local-armazenamento id="finderTipoLocal" v-model="form.tipoLocal"
                            @close="handleSelectTipoLocal" invalidFeedback="" :prefix="prefix + title + ' > '"
                            :label="'Tipo:*'">
                        </lg-finder-page-tipo-local-armazenamento>

                    </b-col>

                    <b-col cols="2" class="text-left">
                        <lg-form-input v-model="form.codigo" label="Identificador:" />
                    </b-col>


                    <b-col cols="2" class="text-left">
                        <lg-form-const-select :disabled="apenasAtivos" label="Situação:" v-model="form.situacao"
                            :options="optionsFilterSituacao" @change="load()" />
                    </b-col>

                    <b-col cols="2">
                        <b-form-checkbox class="mt-3" v-model="form.ondeSouFiscal" @change="load">
                            Onde sou fiscal
                        </b-form-checkbox>
                    </b-col>

                    <b-col cols="3" class="text-right mt-2">
                        <b-button id="limparArmazenamento" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" /> &nbsp;
                            </div>
                            <b-tooltip target="limparArmazenamento" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button id="localizarArmazenamento" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarArmazenamento" title="Localizar"></b-tooltip>
                        </b-button>
                    </b-col>

                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" @row-dblclicked="localArmazenamentoSelect" show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switchGrupo'">
                            <b-form-checkbox :disabld="!temPrivilegioEdicao()" v-model="row.item.situacao"
                                @change="alteraSituacao(row.item)" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>

                    <template v-slot:cell(filho)="row">
                        <b-button :id="row.index + 'filho-button'" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalFilho(row.item)">
                            <b-icon icon="list-nested" />
                            <b-tooltip :target="row.index + 'filho-button'"
                                title="Ver localizações filhas..."></b-tooltip>
                        </b-button>
                    </template>


                    <template v-slot:cell(action)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button'" class="my-2"
                            size="sm" pill variant="primary" @click="editResource(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(remove)="row">
                        <b-button :disabled="!temPrivilegioExclusao()" :id="row.index + 'remove-button'" class="my-2"
                            size="sm" pill variant="primary" @click="removeResource(row.item)">
                            <b-icon icon="trash" />
                            <b-tooltip :target="row.index + 'remove-button'" title="Remover"></b-tooltip>
                        </b-button>
                    </template>


                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <LocalArmazenamentoForm v-if="show" @close="cancelar" :prefix="prefix + title + ' > '" :id="id"
            :departamentoId="departamentoId" :idPai="idPai" />

        <ModalPageLocalArmazenamento v-if="mostrarFilho" @close="cancelar" :prefix="prefix + title + ' > '"
            :id="'modalLocalArmazenamento' + idFinderLocal" :departamentoId="departamentoId" :idPai="idPaiLocal">
        </ModalPageLocalArmazenamento>

    </b-card>
</template>

<script>
import ModalPageLocalArmazenamento from "@/core/components/Modals/ModalPageLocalArmazenamento.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import LgFinderPageTipoLocalArmazenamento from "@/components/Finders/LgFinderPageTipoLocalArmazenamento.vue";
import LocalArmazenamentoForm from "./LocalArmazenamentoForm.vue";
import ConfirmMixin from "@/core/mixins/confirm"
import LocalArmazenamentoService from "@/core/api/LocalArmazenamentoService";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import LgFormInputNumber from "@/core/components/Form/LgFormInputNumber.vue"

export default {
    name: "LocalArmazenamentoList",

    components: {
        LgFormInput,
        LgFormConstSelect,
        LgFinderPageTipoLocalArmazenamento,
        LgFinderPageUnidadeAdministrativa: () => import("@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"),
        LocalArmazenamentoForm,
        ModalPageLocalArmazenamento,
        LgFormInputNumber
    },

    props: {
        codsDepartamentos: {
            type: String,
            default: null
        },
        idPai: {
            type: Number,
            default: null,
        },

        apenasAtivos: {
            type: Boolean,
            default: false,
        },
        idFinderLocal: {
            type: String,
            default: "",
        },
        showCamposCustomizados: Boolean,
        departamento: Object,
        onDblClickLocalArmazenamentoList: Function,
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Local Armazenamento"
        }


    },

    data() {
        return {
            idPaiLocal: null,
            mostrarFilho: false,
            id: null,
            show: false,
            perPage: 10,
            departamentoId: null,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                ondeSouFiscal: false,
                localArmazenamentoPai: null,
                unidadeAdministrativa: {},
                localArmazenamento: {},
                tipoLocal: {},
                descricao: "",
                situacao: 1,
                codigo: "",
            },
            optionsFilterSituacao: [
                { key: "filterSituacao", text: "Todos", value: undefined },
                { key: "filterSituacao", text: "Ativo", value: 1 },
                { key: "filterSituacao", text: "Inativo", value: 0 },
            ],

        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.preencheDepartamento();
        this.$service = new ResourceService(`/api/local-armazenamento`);
        this.$deleteService = new LocalArmazenamentoService();

        if (this.apenasAtivos) {
            this.form.situacao = 1;
        }

    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "id",
                    label: "Código",
                },
                {
                    key: "codigoPai",
                    label: "Código Pai",
                },
                {
                    key: "codigo",
                    label: "Identificador",
                },

                {
                    key: "descricao",
                    label: "Descrição",
                },
                {
                    key: "tipoLocalArmazenamento.descricao",
                    label: "Tipo Local",
                },
                {
                    key: "filho",
                    label: " ",
                    tdClass: "w-1",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                    thClass: "text-left",
                },

                {
                    key: "action",
                    label: " ",
                    tdClass: "w-1",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                    thClass: "text-left",
                },
                {
                    key: "situacao",
                    label: " ",
                    tdClass: "w-1",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                    thClass: "text-left",
                },
                {
                    key: "remove",
                    label: " ",
                    tdClass: "w-1",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                    thClass: "text-left",
                },
            ];
        },
    },
    methods: {
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

        },
        temPrivilegioExclusao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EXCLUIR);

        },

        preencheDepartamento() {
            if (this.departamento && this.departamento.id) {
                this.form.unidadeAdministrativa = this.departamento;
            }
        },
        async load() {
            this.filtro = {};
            this.filtro.idPai = this.idPai;
            if (this.codsDepartamentos && this.codsDepartamentos != "")
                this.filtro.codsDepartamentos = this.codsDepartamentos;
            
            if (this.form.ondeSouFiscal != null)
                this.filtro.ondeSouFiscal = this.form.ondeSouFiscal;

            if (this.form.localArmazenamentoPai && this.form.localArmazenamentoPai != "") {
                this.filtro.idLocalPai = this.form.localArmazenamentoPai;
            }

            if (this.form.descricao && this.form.descricao != "") {
                this.filtro.descricao = this.form.descricao;
            }

            if (this.form.codigo && this.form.codigo != "") {
                this.filtro.codigo = this.form.codigo;
            }

            this.filtro.situacao = null;
            if (this.form.situacao != null) {
                this.filtro.situacao = this.form.situacao;
            }

            if (this.form.unidadeAdministrativa) {
                this.filtro.departamento = this.form.unidadeAdministrativa.id;
            }

            if (this.form.tipoLocal) {
                this.filtro.tipoLocal = this.form.tipoLocal.id;
            }

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });
        },
        clearForm() {
            this.filtro = {};
            this.form = {
                ondeSouFiscal: false,
                unidadeAdministrativa: {},
                tipoLocal: {},
                descricao: "",
                situacao: 1,
                codigo: "",
            };
            this.preencheDepartamento();

            this.load();
        },
        async removeResource(item) {
            this.busy = true;
            await this.$removeResource(item);
            this.busy = false;
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Local Armazenamento?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },


        handleSelectUnidadeAdministrativa(departamento) {
            this.form.unidadeAdministrativa = departamento;
            this.load();

        },

        handleSelectTipoLocal(tipoLocal) {
            this.form.tipoLocal = tipoLocal;
            this.load();

        },

        async localArmazenamentoSelect(item) {
            this.$emit("close", item);
        },

        abrirModalFilho(item) {
            this.id = item.id;
            this.idPaiLocal = item.id;
            this.mostrarFilho = true;
        },
        cancelar() {
            this.id = null;
            this.show = false;
            this.mostrarFilho = false;
            this.load();
        },
        editResource(item) {
            this.departamentoId = this.form.unidadeAdministrativa.id;
            this.id = item.id;
            this.show = true;

        },
        mostrarModal() {
            this.departamentoId = this.form.unidadeAdministrativa.id;
            this.id = null;
            this.show = true;
        }

    },

};
</script>
